module.exports = __webpack_public_path__ + "img/img8.8734abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img8.png
// module id = 272
// module chunks = 0